import claimMessages from '@/modules/Claim/i18n/de'
import damageMessages from '@/modules/Damage/i18n/de'
import appointmentMessages from '@/modules/Appointment/i18n/de'
import documentMessages from '@/modules/Document/i18n/de'

export default {
  claim: { ...claimMessages },
  damage: { ...damageMessages },
  appointment: { ...appointmentMessages },
  document: { ...documentMessages },
  documentContainer: {
    title: 'Immobilienschäden',
    upper1: 'Um Ihre Anfrage bestmöglich zu bearbeiten, bitten wir Sie, uns Ihr Angebot/Rechnung gemäß den folgenden Anweisungen zu senden:',
    upper2: 'Wenn Ihr Angebot/Rechnung auf eine Seite passt, senden Sie es uns bitte im Format pdf, jpg oder png.',
    upper3: 'Wenn Ihr Angebot/Rechnung mehr als eine Seite umfasst, fassen Sie bitte alle Seiten in einer einzigen Datei im pdf-Format zusammen.',
    upper4: "Wenn Sie mehrere Angebote haben, laden Sie diese bitte einzeln hoch, indem Sie auf die Schaltfläche unten klicken. Nachdem alle Dokumente hochgeladen wurden, klicken Sie auf 'Weiter'."
  },
  // actions
  actions: {
    addDamage: 'Hinzufügen',
    login: 'Login',
    select: 'Wählen Sie',
    clear: 'Bereinigen',
    continue: 'Weiter',
    cancel: 'Abbrechen',
    import: 'Importieren',
    export: 'Exportieren',
    exportAll: 'Alle exportieren',
    selectFile: 'Wählen Sie die Datei aus',
    search: 'Suchen',
    save: 'Speichern',
    delete: 'Löschen',
    suppress: 'Löschen',
    confirmAndContinue: 'Bestätigen und fortfahren',
    confirmDommages: 'Schaden validieren',
    goBack: 'Zurückkehren',
    addMoreDamage: 'Schaden hinzufügen',
    accept: 'Akzeptieren',
    confirmWithNoDamages: 'Ich habe keinen Schaden erlitten, fahren Sie mit dem nächsten Schritt for'
  },
  // common damages
  commonDamages: {
    emptyData: 'Es wurden keine Daten zu diesem Schaden angegeben.'
  },

  // view: addDamages
  addDamages: {
    title: 'Erzählen Sie uns mehr über Ihren Schaden',
    buttonTitle: 'Fügen Sie einen Schaden hinzu.'
  },

  // view: multidamageList
  multidamageList: {
    delete: 'Löschen',
    inputTitle: 'Bitte geben Sie uns die Fläche Ihres Raumes an',
    inputTitleTest: 'Wie groß ist die Fläche? (ungefähr)',
    inputHint: 'In Quadratmetern',
    btnContinue: 'Bestätigen und fortfahren',
    btnAddDamage: 'Spezifizieren Sie diese Schäden',
    btnAddDamagePhotoclaim: 'Machen Sie ein Foto des Schadens',
    btnAddDamageModal: 'Diesen Schaden bestätigen',
    btnAddAllDamages: 'Weiter',
    calculateSurfaceLink: {
      text1: 'Sie wissen nicht, wie groß die Fläche ist?',
      text2: 'Wir helfen Ihnen, sie zu berechnen',
      link: 'Berechnen Sie die Fläche'
    },
    calculateSurfaceModal: {
      title: 'Berechnen Sie die Fläche',
      input1: 'Wie viele Schritte haben Sie auf der Breite des Raumes gezählt?',
      input2: 'Wie viele Schritte haben Sie auf der Länge des Raumes gezählt?',
      inputErrorText:
        'Es muss sich um einen numerischen Wert größer als 1 handeln.',
      text: 'Um Ihren Raum zu messen, müssen wir die Breite und die Länge kennen. Gehen Sie von dort aus beide Seiten ab und notieren Sie die Anzahl der Schritte in der Breite und Länge Ihres Raumes.'
    }
  },

  // view: damageMobilier
  damageMobilier: {
    search: {
      predictibles: 'Wählen Sie aus unseren häufigsten Kategorien:',
      containerInputs: 'Suchen Sie in unseren Kategorien',
      categoryList: 'Suchergebnisse',
      containerEmptyTxt1: 'Ihre Suche',
      containerEmptyTxt2: 'ergab keine Ergebnisse',
      containerEmptyTxt3: 'Ergebnisse'
    },
    category: {
      inputTextError: 'Pflichtfelder - numerischer Wert',
      modal1: 'Bevor Sie fortfahren',
      modal2: 'Überprüfen Sie, ob diese Daten korrekt sind:',
      date: 'Kaufdatum',
      price: 'Preis des Kaufs',
      buttonsNextActionsTitle: 'Ja, das ist richtig',
      buttonsNextActionsTitleWhiteBtn: 'Nein, editieren'
    },
    damageResultUptec: {
      title:
        'Die Bewertung Ihres Schadens wird mithilfe dieses Modells vorgenommen:'
    }
  },

  // view: damageItems
  damagedItems: {
    buttonTitle: 'Weiter',
    defaultTitle: 'Welche Räume sind betroffen?',
    defaultText: ''
  },

  // view: damagedParts
  damagedParts: {
    buttonTitle: 'Weiter',
    selectParts:
      'Geben Sie an, welche Medien betroffen sind oder ob eine Reinigung durchgeführt werden muss.',
    multidamageDescription:
      'Wählen Sie alle Teile aus, die von den Schäden betroffen sind.',
    defaultText: '',
    defaultTextExternalDamage: 'Was ist der beschädigte Artikel?'
  },

  // view: damageDetails
  damageDetails: {
    surfaceSmallText: 'In Quadratmetern',
    titleFileInputEnsemble:
      'Nahaufnahmen - Bitte stellen Sie sich so weit wie möglich von den Schäden entfernt auf.',
    titleFileInputPres:
      'Nahaufnahmen - Bitte stellen Sie sich so nah wie möglich an den Schaden heran',
    errorPhoto:
      'Fügen Sie das Foto im Format .png oder .jpg oder .jpeg an. Nicht größer als 6 MB.'
  },

  // view: damagesConfirmed
  damagesConfirmed: {
    titleDamagesConfirmed: 'Zusammenfassung des Schadens',
    photosEnsemble:
      'Nahaufnahmen - Bitte stellen Sie sich so weit wie möglich von den Schäden entfernt auf.',
    photosPres:
      'Nahaufnahmen - Bitte stellen Sie sich so nah wie möglich an den Schaden heran'
  },

  // component: furniture
  furniture: {
    title: 'Mobiliar',
    empty: {
      short: 'Referenz des Schadensfalls fehlt.',
      long: 'Um Schäden an Mobiliar hinzufügen zu können, geben Sie die Schadensreferenz ein.'
    },
    kindOfProperty: 'Art des Eigentums',
    kindOfPropertyOptions: {
      owner: 'Eigentümer',
      renter: 'Mieter'
    }
  },
  // component: warrantySticky
  warrantySticky: {
    materialListBtn: 'Liste des Materials'
  },
  // notification
  notifications: {
    error: {
      0: {
        title:
          'Die Postleitzahl, die Sie zuvor eingegeben haben, wird nicht akzeptiert.',
        body: 'Fehler während der Aktion'
      },
      400: {
        title: 'Obligatorisches Feld wurde nicht ausgefüllt.',
        body: 'Bitte überarbeiten Sie die nicht ausgefüllten Felder.'
      },
      500: {
        title: 'Fehler',
        body: 'Es ist ein Fehler aufgetreten'
      },
      409: {
        title: 'Fehler bei der Identifizierung',
        body: 'Der Schadensfall existiert bereits.'
      },
      title:
        'Die Postleitzahl, die Sie zuvor eingegeben haben, wird nicht akzeptiert.',
      body: 'Fehler während der Aktion'
    },
    addDamage: {
      title: 'Schaden erstellt',
      body: 'Der Schaden wurde korrekt angelegt.'
    },
    newSinister: {
      title: 'Neuer Schadensfall',
      body: 'Die Schadenskennung wurde geändert.'
    },
    deleteDamage: {
      title: 'Schaden beseitigt',
      body: 'Der Schaden wurde korrekt beseitigt.'
    },
    pdfDamages: {
      title: 'Bericht erstellt',
      body: 'Bericht korrekt erstellt'
    },
    pdfMaterial: {
      title: 'Bericht erstellt',
      body: 'Bericht korrekt erstellt'
    },
    mailPdfMaterial: {
      title: 'E-mail gesendet',
      body: 'Richtig gesendete E-Mail',
      error: {
        title: 'Ungültige E-Mail',
        body: 'Bitte geben Sie eine korrekte E-Mail ein.'
      }
    },
    moCalculation: {
      title: 'Preis aktualisiert',
      body: 'Aktuellen Bericht erneut laden'
    },
    changeLanguage: {
      title: 'Sprache ändern',
      body: 'Rücksendung'
    },
    loadSinisterOK: {
      title: 'Schadenfall geladen',
      body: 'Informationen aktualisieren'
    },
    loadSinisterKO: {
      title: 'Fehler Schadenfall',
      body: 'Fehler beim Laden des Schadensfalls'
    },
    paramChanged: {
      title: 'Parameter wurde geändert',
      body: 'Die Tabelle wird automatisch aktualisiert.'
    },
    user: {
      isRequired: {
        title: 'Fehlende Pflichtfelder',
        body: 'Bitte füllen Sie alle Felder korrekt aus.'
      },
      isEmail: {
        title: 'Falsche E-Mail-Adresse',
        body: 'Die eingegebene E-Mail ist ungültig.'
      },
      isSamePassword: {
        title: 'Bitte suchen Sie nach dem Passwort',
        body: 'Die Passwörter stimmen nicht überein'
      },
      createdUser: {
        title: 'UBenutzer angelegt',
        body: 'Ansicht wird aktualisiert'
      },
      modifiedUser: {
        title: 'Benutzer geändert',
        body: 'Ansicht wird aktualisiert'
      },
      deletedUser: {
        title: 'Benutzer gelöscht',
        body: 'Ansicht wird aktualisiert'
      },
      error: {
        400: {
          title: 'Pflichtfelder fehlen',
          body: 'Bitte überprüfen Sie die Pflichtfelder.'
        },
        500: {
          title: 'Fehler bei der Identifizierung',
          body: 'Der Benutzer existiert bereits.'
        },
        409: {
          title: 'Fehler',
          body: 'Es ist ein Fehler aufgetreten'
        }
      }
    },
    images: {
      uploadError: {
        title: 'Upload-Fehler',
        text: 'Fügen Sie das Foto im Format .png oder .jpg oder .jpeg an. Nicht größer als 6 MB.'
      },
      inputImgError: {
        title: 'Upload-Fehler',
        text: 'Beim Hochladen des Fotos ist ein Fehler aufgetreten. Sie können fortfahren, ohne ein Foto hinzuzufügen'
      },
      postImgError: {
        title: 'Upload-Fehler',
        text: 'Beim Hochladen des Fotos ist ein Fehler aufgetreten.'
      }
    }
  },

  // datePicker
  datePicker: {
    literal: 'Datum des Kaufs'
  },

  // damagesTypes view
  damagesTypes: {
    titleNavbar: 'Was ist der Ursprung Ihres Schadens?'
  },

  // damageValidation
  damageValidation: {
    title: 'Immobilienschäden',
    subtitle: 'Basierend auf den bereitgestellten Informationen können wir eine sofortige Entschädigungsbasis von anbieten',
    text1: 'Lösung: Die Reparaturen selbst durchführen',
    text2: 'Gemäß der Beschreibung Ihrer Schäden schlagen wir die folgende sofortige Entschädigung vor:',
    text3: 'Wenn Sie diese Entschädigung akzeptieren, wird sie auf das Bankkonto überwiesen, das für Ihre Beitragszahlungen verwendet wurde, oder per Scheck zugestellt.',
    text4: 'Wenn Sie diese Entschädigung ablehnen, wird sich ein Allianz-Berater innerhalb von 48 Stunden* mit Ihnen in Verbindung setzen.',
    text5: '*Arbeitszeiten und vorbehaltlich außergewöhnlicher Probleme oder Umstände, die außerhalb unserer Kontrolle liegen.',
    age: 'Alter (in Jahren):',
    accordion: {
      title: 'Gemeldete Schäden und Berechnungsmethode',
      base: 'Entschädigungsgrundlage',
      details: 'Entschädigungsdetails',
      calcCompensation: 'Wie wird diese Entschädigung berechnet?'
    },
    modal: {
      title: 'Wie diese Entschädigung berechnet wird',
      subtitle: 'Die einvernehmliche Entschädigung, die Sie für Ihre Immobilienschäden erhalten, wird auf Basis der vollständigen Reparaturkosten berechnet. Diese Gesamtkosten bilden die Grundlage der Entschädigung und umfassen Materialkosten, Werkzeugmiete und eine Entschädigung für den aufgewendeten Zeitaufwand zur Wiederherstellung. \nWenn in Ihrem Vertrag eine Selbstbeteiligung vorgesehen ist, wird diese vom Entschädigungsbetrag abgezogen. \n\n Die Entschädigung kann per Banküberweisung innerhalb der üblichen Fristen mit Ihrer IBAN oder per Bankscheck ausgezahlt werden.',
      button: 'Akzeptieren',
      close: 'Schließen'
    },
    amount: '{amount} €',
    actions: {
      primary: 'Ja, ich akzeptiere die vorgeschlagene Entschädigung',
      secondary: 'Ich möchte diese Bewertung mit einem Berater besprechen',
      tertiary: 'Nein, ich wollte eine andere Lösung'
    },
    materialsList: 'Liste der Ausrüstung',
    upptecDossier: 'Bericht Mobiliar',
    mobilier: {
      title: 'Möbelschäden',
      solution: 'Lösung:',
      text1: 'Sofortige Entschädigung erhalten',
      text2: 'Basierend auf der Beschreibung Ihrer Schäden bieten wir Ihnen die folgende sofortige Entschädigung an:',
      text3: 'Wenn Sie diese Entschädigung akzeptieren, wird sie auf das Bankkonto überwiesen, das für Ihre Beitragszahlungen verwendet wird, oder per Scheck ausgezahlt.',
      text4: 'Wenn Sie diese Entschädigung ablehnen, wird sich ein Allianz-Berater innerhalb von 48 Stunden* mit Ihnen in Verbindung setzen.',
      text5: '*Während der Geschäftszeiten und außer bei außergewöhnlichen oder unvorhersehbaren Problemen.',
      actions: {
        primary: 'Diese Entschädigung akzeptieren',
        secondary: 'Diese Entschädigung ablehnen'
      }
    }
  },
  damageFraisValidation: {
    title: 'Kosten im Zusammenhang mit dem Schadenfall',
    solution: 'Lösung:',
    text: 'Rückerstattung mit Nachweis erhalten',
    text1: 'Basierend auf der Beschreibung Ihrer entstandenen Kosten bieten wir Ihnen die folgende Rückerstattung mit Nachweis an:',
    text2: 'Wenn Sie diese Rückerstattung akzeptieren, müssen Sie uns Ihre Nachweise direkt über Ihr Kundenkonto übermitteln.',
    text3: 'Wenn Sie diese Rückerstattung ablehnen, wird sich ein Allianz-Berater innerhalb von 48 Stunden* mit Ihnen in Verbindung setzen.',
    text4: '*Arbeitszeiten und außer bei außergewöhnlichen oder unvorhersehbaren Problemen.',
    actions: {
      primary: 'Diese Entschädigung akzeptieren',
      secondary: 'Diese Entschädigung ablehnen'
    }
  },

  // common
  common: {
    surface: 'Oberfläche',
    line: 'Lineal',
    distance: 'Entfernung',
    actualCalc: 'Aktuelle Berechnung',
    selectOnTheMap: 'Wählen Sie auf der Karte zum Messen aus.',
    mapAction: 'Auf der Karte messen',
    mapActionLine: 'Auf der karte messen',
    min: 'Minimum',
    max: 'Maximal',
    total: 'Gesamt',
    recommended: 'Empfohlen',
    standard: 'Standard',
    noFile: 'Keine Datei ausgewählt',
    email: 'Elektronische Post',
    search: 'Suche',
    results: 'Ergebnisse',
    noresults: {
      short: 'Keine Ergebnisse',
      long: 'Es gibt keine Ergebnisse für Ihre Suche.'
    },
    true: 'Ja',
    false: 'Nein',
    noOptions: 'Ohne Option',
    noSelected: 'Keine ausgewählt.',
    agentView: 'Agentenansicht',
    managerView: 'Manageransicht',
    unit: '0 der Einheiten | x {count} Einheit | x {count} der Einheiten.'
  },

  // view: error
  errorView: {
    title: 'Ein Fehler ist aufgetreten',
    text: 'Unser Team arbeitet daran, das Problem so schnell wie möglich zu beheben.'
  },

  // view: error
  timedoutView: {
    title: 'Der Link ist abgelaufen',
    text: {
      upper: `Es tut uns leid, aber der Link ist abgelaufen und nicht mehr gültig`,
      lower: `Kontaktieren Sie unsere Operatoren für einen neuen Link`
    }
  },

  // cart
  cart: {
    title: 'Liste der eingeführten Schäden'
  },

  // component: form-container
  formContainer: {
    mursTitle: 'Anzahl der betroffenen Wände'
  },

  // component: customImage
  customImageInput: {
    default: {
      takeScreenshot: 'Rahmen Sie den Schaden ein',
      repeat: 'Wiederholen',
      usePhoto: 'Foto verwenden'
    },
    guideCamera: {
      takeScreenshot:
        'Rahmen Sie den Schaden in der {guideIndexLiteral} Anleitung ein',
      first: 'erste',
      second: 'sekunde',
      third: 'dritter'
    },
    cornersCamera: {
      takeScreenshot: 'Fotografieren Sie von der Mitte des Raums aus jede Ecke',
      endPhotos: 'Abschließen'
    }
  },
  otpView: {
    title: 'Hallo',
    text: {
      upper: `Willkommen in Ihrem Bereich „Meine Schäden“, in dem Sie die Vollständigkeit Ihrer Schäden beschreiben können.`,
      upper2: `Um darauf zuzugreifen, geben Sie bitte den an Ihr Telefon gesendeten Code unter ein `,
      upper3: `Dieser Schritt kann bis zu 2 Minuten dauern.`,
      lower1: `Bitte geben Sie Ihren Bestätigungscode ein.`,
      lower2: `Ein Code wurde an Ihr Telefon unter gesendet `,
      nocode: `Haben Sie Ihren Code nicht erhalten?`,
      resend: 'Senden Sie eine SMS erneut',
      resendNotification: 'Weitergeleitete Nachricht',
      errorNotification: 'Falscher Code',
      popup: {
        text1: `Wenn Sie den Authentifizierungscode nicht erhalten haben, empfehlen wir diese drei Schritte : `,
        list1_1: `Überprüfen Sie, ob die Telefonnummer`,
        list1_2: `passt zu deinem`,
        list2: `Wenn die Nummer übereinstimmt, schließen Sie dieses Fenster und klicken Sie auf “SMS erneut senden“.`,
        list3: `Wenn die Nummer nicht übereinstimmt, bitten wir Sie, sie auf Ihrer einzugeben `,
        link1: `Kundenbereich`,
        text2: `Ein Allianz Berater ruft Sie innerhalb von 24 Stunden zurück.`,
        bpce: {
          text3: 'Sollte die Nummer nicht übereinstimmen, bitten wir Sie, sich an Ihren BPCEAI-Berater zu wenden.'
        }
      }
    },
    bpce: {
      title: 'Hallo',
      upper1: 'Ihr Kostenvoranschlag/Rechnung wird von unserem Team bearbeitet, wir melden uns so schnell wie möglich bei Ihnen.'
    }
  },
  // legal conditions
  cookiesAndLegal: {
    general: {
      title: 'Allgemeine Geschäftsbedingungen',
      paragraph1:
        'Bevor Sie beginnen, lesen Sie bitte unsere Verwendung von Cookies in Ihrem Browser und unsere Nutzungsbedingungen. Indem Sie auf die Schaltfläche „Akzeptieren“ klicken, bestätigen Sie, dass Sie die Bedingungen für diesen Dienst gelesen und verstanden haben.'
    },
    cookies: {
      title: 'COOKIES-RICHTLINIE',
      paragraph1: {
        list1: `Ihnen wird dann die Cookie-Richtlinie (im Folgenden als „die Cookie-Richtlinie“ oder „die Richtlinie“ bezeichnet) angezeigt, die die Webplattform https://mavalue.plataforma-smart.com/ (im Folgenden als „die Plattform“ oder „MAValue“), Eigentum von Multiassistance, S.A. (im Folgenden als „Multiassistance“ oder „wir“ bezeichnet).`,
        list2: `Der Zweck dieser Cookie-Richtlinie besteht darin, Ihnen zu helfen, die Verwendung von Cookies auf dieser Webplattform, ihre Arten, ihren Zweck und ihre Dauer zu verstehen, und Ihnen auch die Optionen aufzuzeigen, die Sie zum Konfigurieren, Verwalten oder Ablehnen haben diese.`,
        list3: `NEHMEN SIE SICH BITTE EIN PAAR MINUTEN, UM UNSERE COOKIES-RICHTLINIEN ZU LESEN, ES DAUERT NICHT LANGE. WIR MÖCHTEN EINFACH, KLAR UND TRANSPARENT ERKLÄREN, WIE WIR IHRE PERSONENBEZOGENEN DATEN UND IHRE RECHTE VERARBEITEN UND SCHÜTZEN. IHRE SICHERHEIT UND DIE IHRER PERSONENBEZOGENEN DATEN IST FÜR UNS GRUNDLEGEND, UND WIR NEHMEN IHREN ANGEMESSENEN SCHUTZ SEHR ERNST.`,
        list4: `WIR EMPFEHLEN IHNEN AUCH, UNSERE DATENSCHUTZERKLÄRUNG ZU LESEN.`
      },
      paragraph2: {
        title: `Was sind Cookies?`,
        body: `Cookies sind kleine Dateien oder kleine Geräte, die auf Ihr Endgerät heruntergeladen und gespeichert werden (d. h. das Gerät, von dem aus Sie auf die Plattform zugreifen: der Computer, das Mobiltelefon, das Tablet oder ein anderes verbundenes Gerät …) und die der Plattform oder dem Website, um Informationen zu Ihrem Besuch zu speichern.
        Cookies können abhängig von mehreren Parametern unterschiedlicher Art sein:`,
        list1: `Abhängig von der Einheit, die das Team oder die Domäne verwaltet, von der die Cookies gesendet und wo die erhaltenen Daten verarbeitet werden, können wir Folgendes unterscheiden:`,
        list2: `Für uns spezifische Cookies: Dies sind diejenigen, die von Geräten oder einer Domäne, die von Multiassistance verwaltet werden und von denen der vom Benutzer angeforderte Dienst ausgeht, an das Endgerät des Benutzers gesendet werden.`,
        list3: `Cookies von Drittanbietern: Dies sind diejenigen, die von Geräten oder einer Domäne, die nicht von Multiassistance verwaltet werden, sondern von einer anderen Stelle, die die von den Cookies erhaltenen Daten verarbeitet, an das Endgerät des Benutzers gesendet werden. Wenn Cookies von Geräten oder einer Domäne installiert werden, die von Multiassistance verwaltet werden, die von ihnen gesammelten Informationen jedoch von einem Dritten verwaltet werden, können sie nicht als Cookies betrachtet werden, die für Multiassistance spezifisch sind. In diesem Sinne kann Multiassistance die Dienste von Analyse- und Messunternehmen nutzen, um das Surfverhalten der Benutzer auf der Plattform zu messen und/oder zu analysieren, und in Anbetracht dessen, dass sie in seinem Namen und in seiner Vertretung handeln, aufgrund der Analyse der durch die Verwendung der Cookies dieser Dienste erhaltenen Daten, alles mit dem Ziel, den von Multiassistance angebotenen Dienst zu verbessern.`,
        list4: `Je nach dem Zweck, für den die durch Cookies erhaltenen Daten verarbeitet werden, können wir unterscheiden zwischen:`,
        list5: `Technische Cookies: Dies sind diejenigen, die es dem Benutzer ermöglichen, durch die Plattform zu navigieren und die verschiedenen Optionen oder die verschiedenen dort verfügbaren Dienste zu nutzen, wie z Zugriffsdaten, Erinnerung an die Elemente, die eine Anfrage zur Registrierung oder Teilnahme an einer Veranstaltung darstellen, die Verwendung von Sicherheitselementen während der Navigation, das Speichern von Inhalten für die Verbreitung von Videos oder Ton oder das Teilen von Inhalten in sozialen Netzwerken.`,
        list6: `Personalisierungs-Cookies: Dies sind Cookies, die dem Benutzer den Zugriff auf den Dienst mit bestimmten vordefinierten allgemeinen Merkmalen gemäß einer Reihe von Kriterien auf dem Endgerät des Benutzers ermöglichen, wie z. die regionale Konfiguration, um unter anderem auf den Dienst zuzugreifen.`,
        list7: `Analyse-Cookies: Dies sind diejenigen, die es ihrem Manager ermöglichen, das Verhalten der Benutzer der Websites, mit denen sie verbunden sind, zu überwachen und zu analysieren. Die mit Hilfe dieser Art von Cookies gesammelten Informationen werden verwendet, um die Aktivität auf der Plattform zu messen und um Surfprofile der Benutzer auf den betreffenden Websites, in den Anwendungen und auf den Plattformen im Hinblick auf Verbesserungen zu erstellen: basierend auf der Analyse der von den Benutzern des Dienstes konsultierten Daten.`,
        list8: `Werbe-Cookies: Dies sind diejenigen, die eine möglichst effiziente Verwaltung der Werbeflächen ermöglichen, die ggf. vom Herausgeber auf einer Webseite, einer Anwendung oder einer Plattform eingefügt wurden, von der aus der angeforderte Dienst erfolgt auf der Grundlage von Kriterien wie bearbeitetem Inhalt oder Anzeigehäufigkeit von Werbung bereitgestellt werden.`,
        list9: `Verhaltensbezogene Werbe-Cookies: Dies sind Cookies, die eine möglichst effiziente Verwaltung der Werbeflächen ermöglichen, die der Herausgeber ggf bereitgestellt. Diese Cookies speichern Informationen über das Benutzerverhalten, die durch die kontinuierliche Beobachtung ihrer Surfgewohnheiten gewonnen wurden, und ermöglichen die Entwicklung eines darauf basierenden spezifischen Profils.`,
        list9_1: `Je nachdem, in welchem Zeitraum sie im Endgerät aktiv sind (Zeitlichkeit), können wir folgendes unterscheiden:`,
        list10: `Session-Cookies: Dies sind Cookies, die dazu dienen, Daten zu sammeln und zu speichern, während der Benutzer auf die Plattform zugreift.`,
        list11: `Persistente Cookies: Dies sind Cookies, bei denen die Daten weiterhin im Endgerät gespeichert werden und die für einen Zeitraum verarbeitet werden können, der von der für das Cookie verantwortlichen Person festgelegt wird und von wenigen Minuten bis zu mehreren Jahren variieren kann.`,
        footer: `Sie können die Informationen zu Cookies und anderen Tracern einsehen, die von der Nationalen Kommission für Datenverarbeitung und Freiheiten (CNIL) bereitgestellt werden, indem Sie hier klicken.`
      },
      paragraph3: {
        title: `Welche Cookies werden auf der Plattform verwendet?`,
        body: `Diese Plattform verwendet technische Cookies, die erforderlich sind, um die Benutzernavigation und die Funktionalität der Plattform zu ermöglichen und zu optimieren.
        Die verwendeten Cookies sind notwendig, um die Navigation auf der Plattform zu ermöglichen und ihr ordnungsgemäßes Funktionieren zu gewährleisten, daher können sie vom Benutzer nicht abgelehnt werden, und ihre Deaktivierung oder Löschung macht die Nutzung der Plattform unmöglich. .
        Nachfolgend werden die innerhalb dieser Plattform verwendeten Cookies identifiziert: `,
        list1: `Cookies`,
        list1_1: `mavalue.plataforma-smart`,
        list2: `Zweck`,
        list2_1: `Cookie, damit Sie eingeloggt bleiben`,
        list3: `Verwaltung`,
        list3_1: `Reinigen`,
        list4: `Dauer`,
        list4_1: `1 Jahr `
      },
      paragraph4: {
        title: `Aktualisierungen und Änderungen der Cookie-Richtlinie.`,
        body: `Diese Cookie-Richtlinie kann gemäß den gesetzlichen oder behördlichen Anforderungen oder mit dem Zweck geändert werden, diese Richtlinie an die Anweisungen der Nationalen Kommission für Informatik und Freiheiten (CNIL) anzupassen. In diesem Sinne empfehlen wir den Benutzern, sie regelmäßig zu konsultieren . `
      }
    },
    legal: {
      title: 'RECHTLICHER HINWEIS',
      paragraph1: {
        list1: `Der Zugang zu den digitalen Lösungen und zu allen auf dieser Plattform enthaltenen Funktionalitäten sind in den Dienstleistungen enthalten, die von dem Unternehmen vertraglich vereinbart wurden, das das Recht hat, sie zu nutzen (das Unternehmen), in dessen Namen Sie die Nutzungsbedingung erwerben. Der Zugriff, das Surfen und die Nutzung der Plattform setzt voraus, dass Sie die Bedingungen des Benutzers derselben erfüllen (im Folgenden als „der Benutzer“ bezeichnet) und sich daher der ausdrücklichen und vorbehaltlosen Annahme aller darin enthaltenen Bedingungen durch den Benutzer anschließen dieser rechtlichen Hinweise, weshalb wir empfehlen, sie sorgfältig zu lesen, damit es im Falle von Meinungsverschiedenheiten ausreicht, sie nicht mit den dafür vorgesehenen Mitteln zu akzeptieren, was die Nutzung der Plattform, der Dienste und der Dienste unmöglich macht durch letztere eingerichtete Funktionalitäten.`
      },
      paragraph2: {
        title: `ALLGEMEINE INFORMATIONEN.`,
        subParagraph1: {
          title: `EDITOR`,
          line1: `MULTIASSISTANCE, S.A. (im Folgenden als „Multiassistance“ oder „wir“ bezeichnet); `,
          line2: `Gesellschaft mit beschränkter Haftung mit einem Stammkapital von 48.494,10 Euro`,
          line3: `146 Boulevard de Charonne`,
          line4: `75020 Paris`,
          line5: `Innergemeinschaftliche Umsatzsteuer-Identifikationsnummer: FR 62413114901`,
          line6: `Name des Veröffentlichungsleiters: Mr. Íñigo Astarloa Echevarrieta`,
          line7: `Tel: 01 40 09 36 60`,
          line8: `E-Mail: info@multiasistencia.com; contact.clients@Multiassistance.com`
        },
        subParagraph2: {
          title: `HOSTER`,
          line1: `Amazon Web Services EMEA SARL`,
          line2: `38 avenue John F. Kennedy, L-1855 Luxembourg`,
          line3: `Fax: 352 2789 0057`
        }
      },
      paragraph3: {
        title: `WEBPLATTFORM: VERWENDUNG, ZWECK UND ANWENDBARE RECHTSVORSCHRIFTEN.`,
        list1: `Multiassistance ist ein Unternehmen, das sich auf die Verwaltung und Reparatur von Schäden in der Hausrat- und Gewerbeversicherung für Versicherungsunternehmen spezialisiert hat und im Rahmen dieser Tätigkeit seinen Kunden digitale Lösungen zur Optimierung und Digitalisierung ihrer Betriebsprozesse zur Verfügung stellt.`,
        list2: `Die Plattform ist der Kanal, über den autorisierte Benutzer die verschiedenen Lösungen nutzen können, die sie vertraglich vereinbart haben oder die das Unternehmen, dem sie angehören oder mit dem sie eine Kooperationsbeziehung haben, vertraglich vereinbart hat. `,
        list3: `Der Zugang zu den digitalen Lösungen und zu allen auf dieser Plattform enthaltenen Funktionalitäten sind in den Dienstleistungen enthalten, die von dem Unternehmen vertraglich vereinbart wurden, das das Recht hat, sie zu nutzen (das Unternehmen), in dessen Namen Sie die Nutzungsbedingung erwerben. Der Zugriff auf und die Nutzung der Plattform impliziert die Annahme aller vorliegenden Bedingungen sowie aller anderen Bedingungen, die auf der Grundlage bestimmter gegenwärtiger oder zukünftiger Anforderungen des Dienstes festgelegt, geändert und/oder erweitert werden können. Multiassistance ist berechtigt, den Inhalt dieser Bedingungen sowie die auf der Plattform eingerichteten Dienste und Funktionalitäten jederzeit zu ändern, wobei zu verstehen ist, dass die Veröffentlichung dieser betreffenden Änderungen und Änderungen über dieses Kommunikationsmittel ausreichend ist, ohne dass dies jedoch der Fall ist beeinträchtigt nicht die Möglichkeit des Benutzers, die betreffenden Änderungen zu akzeptieren oder nicht zu akzeptieren. Im Falle der Nichtannahme könnte dies dazu führen, dass die Plattform nicht für alle oder bestimmte von dieser vorgegebene Funktionalitäten genutzt werden kann.`
      },
      paragraph4: {
        title: `ZUGANGS- UND NUTZUNGSBEDINGUNGEN.`,
        body1: `Der Benutzer verpflichtet sich, die Plattform sowie die daraus hergestellten Inhalte, Produkte und Dienstleistungen jederzeit in Übereinstimmung mit den geltenden Gesetzen, unter den vorliegenden Bedingungen, im moralischen Sinne und im Allgemeinen angemessen und rechtmäßig zu nutzen akzeptierte gute Gewohnheiten sowie für die öffentliche Ordnung. `,
        body2: `Darüber hinaus stimmt der Nutzer der Plattform Folgendem zu:`,
        list1: `Gewährleistung der Authentizität, Richtigkeit, Aktualisierung und Genauigkeit aller über die Plattform übermittelten Daten, mit der Angabe, dass ansonsten der Benutzer allein verantwortlich ist.`,
        list2: `Nutzung der Plattform ausschließlich für die von Multiassistance vereinbarten Zwecke und Funktionalitäten, dem Benutzer ist es daher untersagt, die Plattform für andere Zwecke oder andere Mittel zu nutzen.`,
        list3: `Rechtmäßige und legitime Nutzung der Plattform, Vermeidung jeglicher unbefugter, betrügerischer, illegaler oder illegitimer Nutzung derselben und/oder der von ihr erstellten Inhalte und Informationen, Vermeidung von Verstößen gegen diese rechtlichen Hinweise sowie die geltenden Vorschriften, die Rechte und legitimen Interessen von Multiassistance oder anderen Dritten zu verletzen, die von dieser Aktion betroffen sein könnten.`,
        list4: `Verursachen Sie keinen Schaden an den physischen oder logischen Systemen der Plattform, ihren Lieferanten oder Dritten; nicht zu versuchen, deren Sicherheits- oder Authentifizierungsmaßnahmen zu verletzen, keine Aktionen durchzuführen, die eine unverhältnismäßige oder unnötige Überlastung der Infrastruktur oder der Kommunikationsumgebung in Bezug auf die Plattform und den Dienst verursachen, letztere auf die eine oder andere Weise anzugreifen. Multiassistance kann alle vorbeugenden oder korrigierenden Maßnahmen ergreifen, die als notwendig erachtet werden, um seine Interessen in Übereinstimmung mit dem korrekten Funktionieren der Plattform, des Dienstes und der angegebenen Funktionalitäten zu schützen.`,
        list5: `Führen Sie keine Computerviren oder andere physische oder logische Systeme, die Schäden verursachen können, wie Viren, bösartigen Code oder andere schädliche Programme oder Archive, in das Netzwerk ein oder verbreiten Sie sie nicht.`,
        list6: `Versuchen Sie nicht, auf Daten oder andere Informationen, die von der Plattform verarbeitet werden, zuzugreifen, diese zu verwenden und/oder zu manipulieren.`,
        list7: `Insbesondere und nur zu Informationszwecken und nicht abschließend verpflichtet sich der Nutzer, keine Informationen, Daten, Inhalte oder Nachrichten zu übermitteln, zu verbreiten oder Dritten zur Verfügung zu stellen, die die Rechte von Multi-Assistance oder Dritten verletzen könnten.`,
        list8: `Nicht unbefugt darauf zuzugreifen oder eine falsche Identität zu verwenden, sich als Dritte auszugeben oder ein Profil zu verwenden oder andere Handlungen vorzunehmen, die Verwirrung stiften oder hinsichtlich der korrekten Identität des betreffenden Benutzers irreführen könnten.`
      },
      paragraph5: {
        title: `INDUSTRIELLES UND GEISTIGES EIGENTUM.`,
        list1: `Der Benutzer erkennt an und akzeptiert, dass alle geistigen und gewerblichen Eigentumsrechte auf der Plattform und allen damit verbundenen Elementen Multiassistance oder Dritten zustehen, die Multiassistance ausdrücklich zu diesem Zweck autorisiert haben.`,
        list2: `Der Zugriff auf oder die Navigation auf der Plattform impliziert unter keinen Umständen den Widerruf, die Übertragung, die Lizenzierung oder die vollständige oder teilweise Übertragung dieser Rechte, es sei denn, das Gegenteil ist ausdrücklich schriftlich festgelegt.`,
        list3: `Alle geistigen und gewerblichen Eigentumsrechte an den Inhalten und/oder Diensten der Plattform sind vorbehalten, und insbesondere ist es untersagt, sie auf irgendeine Weise oder in irgendeinem Format zu ändern, zu kopieren, zu reproduzieren, öffentlich zu kommunizieren, umzuwandeln oder zu verbreiten , deren Inhalte ganz oder teilweise für öffentliche oder kommerzielle Zwecke enthalten sind, es sei denn, die vorherige, ausdrückliche und schriftliche Genehmigung der jeweiligen Eigentümer wurde eingeholt.`,
        list4: `Der Benutzer, der gegen diese Beschränkungen und Verbote verstößt, erkennt an, dass er die ausschließliche Verantwortung übernimmt, wodurch Multiassistance oder andere Dritte, die von der Aktion des Benutzers betroffen sein könnten, von jeglicher Verantwortung befreit sind.`
      },
      paragraph6: {
        title: `GEWÄHRLEISTUNGS- UND HAFTUNGSAUSSCHLUSS.`,
        list1: `Multiassistance ergreift mehrere Maßnahmen, um die Plattform und die Inhalte vor Computerangriffen durch Dritte zu schützen. In jedem Fall ist es wichtig, dass die Benutzer dafür verantwortlich sind, alle geeigneten technischen Maßnahmen zu ergreifen, um die Bedrohungen, denen sie ausgesetzt sind, angemessen zu kontrollieren, einschließlich der Aktualisierung von Systemen zur Erkennung bösartiger Software wie Viren, Trojaner usw. sowie Sicherheitspatches für betroffene Browser.`,
        list2: `Der Benutzer ist für die sichere Aufbewahrung seiner Zugangscodes verantwortlich und muss deren Verwendung durch unbefugte Dritte vermeiden und die erforderlichen Sicherheitsmaßnahmen ergreifen, um die Vertraulichkeit der im Zusammenhang mit der Plattform eingerichteten Zugangs- und Verifizierungssysteme oder Codes zu wahren. Multiassistance lehnt jede Verantwortung im Falle von Fahrlässigkeit, Unvorsichtigkeit oder Missbrauch durch den Benutzer oder einen unbefugten Dritten ab und haftet in keinem Fall für Schäden und Nachteile, die aus diesem unbefugten Zugriff entstehen können.`,
        list3: `Multiassistance behält sich das Recht vor, ohne vorherige Ankündigung den Zugang für Benutzer zu sperren, die gemäß ihrem Kriterium die Nutzungsregeln der Plattform nicht einhalten, und darüber hinaus die entsprechenden rechtlichen Schritte einzuleiten, ohne dass dies der Fall ist begründet kein Recht auf Schadensersatz zugunsten des möglicherweise betroffenen Benutzers.`,
        list4: `Multiassistance lehnt jede Verantwortung ab, die sich aus Schäden und Verlusten jeglicher Art ergeben, die sich aus der Nutzung der Dienste und Inhalte durch Benutzer ergeben können oder die sich aus dem Mangel an Informationen, Genauigkeit oder Wahrhaftigkeit ergeben, die diese als Teil der Plattform bereitstellen und der Dienst. Unter keinen Umständen kann Multiassistance für die Nutzung der Plattform durch Benutzer und/oder Dritte sowie für daraus resultierende Schäden und Verluste haftbar gemacht werden.`
      },
      paragraph7: {
        title: `DIE ÄNDERUNG DER RECHTLICHEN HINWEISE.`,
        list1: `Multiassistance behält sich das Recht vor, die in diesen rechtlichen Hinweisen enthaltenen Informationen zu ändern, um sie an zukünftige gesetzliche, lehrmäßige oder rechtswissenschaftliche Entwicklungen anzupassen, die sich aus der Anwendung ergeben, sei es für technische, betriebliche, kommerzielle, gesellschaftsrechtliche und unternehmerische, mit vorheriger und angemessene Benachrichtigung der Benutzer über die Änderungen, die so bald wie möglich stattfinden. In jedem Fall wird empfohlen, bei jedem Zugriff auf die Plattform die rechtlichen Hinweise sorgfältig zu lesen.`,
        list2: `Im Zweifelsfall bezüglich dieser rechtlichen Hinweise kann der Benutzer Multiassistance per E-Mail unter der folgenden E-Mail-Adresse kontaktieren: info@multiasistencia.com“.`
      }
    },
    bpce: {
      general: {
        title: 'Verwendung von Cookies',
        paragraph1: 'Diese Website verwendet technische Cookies, um ihre ordnungsgemäße Funktion zu gewährleisten.',
        title2: 'Datenschutzrichtlinie',
        paragraph2: 'Multiassistance wird Ihre persönlichen Daten verarbeiten, um Ihren Schadenfall zu verwalten. Sie können jederzeit Ihr Recht auf Zugang, Berichtigung, Löschung sowie die im Rahmen der DSGVO vorgesehenen Rechte ausüben. Für weitere Informationen konsultieren Sie bitte ',
        policyText: 'unsere vollständige Datenschutzrichtlinie.',
        acceptText: 'Ich habe die ',
        privacyText: 'Datenschutzrichtlinie gelesen und akzeptiert'
      },
      privacy: {
        title: 'Datenschutzrichtlinie',
        paragraph1: 'MULTIASSISTANCE, S.A., mit Sitz in der 19 rue Emmy Noether, 93400 Saint-Ouen-sur-Seine (Frankreich), eingetragen im Handelsregister von Bobigny unter der Nummer 413 114 901, informiert Sie als Verantwortlicher für die Datenverarbeitung darüber, dass wir über BillMA Ihre personenbezogenen Daten (Identifikationsdaten, versicherungsbezogene Daten, Kontaktdaten und finanzielle Daten im Zusammenhang mit Ihrer Versicherung) verarbeiten, um den mit Ihrem Schadenfall verbundenen Kostenvoranschlag zu verwalten und zu überprüfen, basierend auf der Erfüllung Ihres Versicherungsvertrags. In diesem Zusammenhang informieren wir Sie darüber, dass uns Ihre Daten von BPCE Assurances IARD übermittelt wurden.',
        paragraph2: 'Diese Daten werden nur so lange aufbewahrt, wie es für die Erfüllung des angegebenen Zwecks und zur Einhaltung der geltenden gesetzlichen Verpflichtungen erforderlich ist.',
        paragraph3: 'Ebenso informieren wir Sie darüber, dass Ihre Daten nicht an Dritte weitergegeben werden, es sei denn, dies ist gesetzlich vorgeschrieben.',
        paragraph4: 'Schließlich informieren wir Sie darüber, dass Sie Ihre Rechte auf Zugang, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit oder Widerspruch ausüben können, indem Sie eine E-Mail an ',
        paragraph5: 'Wenn Sie der Meinung sind, dass Ihre Rechte nicht ordnungsgemäß gewahrt wurden, können Sie eine Beschwerde bei der Nationalen Kommission für Informatik und Freiheiten (',
        paragraph6: ') einreichen. Wir empfehlen Ihnen jedoch, sich vor Einreichung einer Beschwerde oder Reklamation mit unserem Datenschutzbeauftragten (',
        paragraph7: ') in Verbindung zu setzen, um die konkrete Situation zu analysieren und gegebenenfalls eine wirksame und einvernehmliche Lösung zu finden.'
      }
    }
  },
  summary: {
    title: 'Zusammenfassung',
    billma: {
      solution: 'Lösung: Eigenen Handwerker auswählen',
      text1: 'Ihr Kostenvoranschlag wurde akzeptiert.',
      text2: 'Sie erhalten so schnell wie möglich eine erste Zahlung von 50% des Gesamtbetrags inkl. MwSt., damit Sie mit den Arbeiten mit Ihrem Handwerker beginnen können.',
      text3: 'Der Restbetrag wird nach Vorlage der Rechnung gezahlt, die Sie uns über Ihren Kundenbereich oder die mobile App Mon Allianz zusenden müssen.'
    },
    immobilier: {
      title: 'Immobilienschäden',
      ren: {
        compensation: 'Ausgewählter Termin',
        details: 'Funktionsdetails',
        modal: {
          title: 'Funktionsdetails',
          subtitle: 'Die Entschädigung, die Sie für Ihre Immobilienschäden erhalten, hängt ab von:',
          list1: 'Wenn Sie die Reparatur durch einen zugelassenen Handwerker wählen, wählen Sie Datum und Uhrzeit des ersten Termins basierend auf den vorgeschlagenen Zeitfenstern. Der Handwerker führt alle Arbeiten im Zusammenhang mit Ihren Immobilienschäden durch und koordiniert sich mit Ihnen, falls mehrere Eingriffe erforderlich sind.',
          list2: 'Allianz übernimmt direkt die Reparaturen, mit Ausnahme eines möglichen Selbstbehalts, der von Ihnen getragen und direkt an den Handwerker am Ende seiner Leistung gezahlt werden muss.',
          confirm: 'Akzeptieren'
        },
        solution: 'Lösung: Wählen Sie einen von Allianz zugelassenen Fachmann',
        text1: 'Der Fachmann wird sich innerhalb von 48h* mit Ihnen in Verbindung setzen, um das Datum und die Uhrzeit Ihres Termins zu bestätigen.',
        text2: 'Ein Berater des Allianz-Reparaturdienstes steht Ihnen ebenfalls für Fragen zu Ihrem Fall zur Verfügung.',
        phoneText: '(Kosten eines Ortsgesprächs)'
      },
      franchise: {
        title: 'Selbstbehalt',
        subtitle: 'Selbstbehalt zulasten des Kunden'
      },
      billma: 'Akzeptierter Kostenvoranschlag',
      gag: {
        compensation: 'Details Ihrer Entschädigung',
        indemnisation: 'Gesamtbetrag',
        details: 'Gemeldete Schäden',
        dommages: 'Interne Schäden',
        calcule: 'Wie wird diese Entschädigung berechnet?',
        modal: {
          title: 'Wie wird diese Entschädigung berechnet?',
          subtitle: 'Die einvernehmliche Entschädigung, die Sie für Ihre Immobilienschäden erhalten, wird auf Grundlage der Gesamtkosten der Reparatur berechnet. Diese Kosten umfassen Material, Werkzeugmiete und eine Entschädigung für den Zeitaufwand. Wenn Sie diese Entschädigung akzeptieren, wird ein möglicher Selbstbehalt von der Gesamtbasis abgezogen.',
          confirm: 'Akzeptieren'
        },
        franchise: {
          title: 'Selbstbehalt',
          subtitle: 'Selbstbehalt zulasten des Kunden'
        },
        solution: 'Lösung: Die Arbeiten selbst durchführen'
      }
    },
    mobilier: {
      title: 'Möbelschäden',
      subtitle: 'Details Ihrer Entschädigung',
      indemnisation: 'Gesamtbetrag',
      details: 'Gemeldete Schäden',
      total: 'Gesamtentschädigungsbasis',
      solution: 'Lösung: Sofortige Entschädigung erhalten',
      description: 'Sie erhalten so bald wie möglich die Zahlung Ihrer Entschädigung, die es Ihnen ermöglicht, Ihre beschädigten Möbel zu ersetzen.'
    },
    frais: {
      title: 'Kosten im Zusammenhang mit dem Schadenfall',
      recherche: 'Lecksuche',
      deplacement: 'Möbelbewegung',
      mise: 'Sicherheitsmaßnahmen',
      provisorie: 'Vorübergehende Reparatur',
      gag: {
        title: 'Selbstbehalt',
        subtitle: 'Selbstbehalt zulasten des Kunden',
        total: 'Gesamtentschädigung'
      },
      solution: 'Lösung: Erstattung gegen Nachweis erhalten',
      description: 'Um die Erstattung Ihrer angefallenen Kosten schnellstmöglich zu erhalten, übermitteln Sie uns bitte Ihre Nachweise direkt über Ihren Kundenbereich, Rubrik "Meine Vorgänge".'
    },
    confirm: 'Akzeptieren und beenden'
  },
  textDescriptionError:
    'Bitte vervollständigen Sie die Beschreibung des Schadens, bevor Sie fortfahren',
  stepper: {
    step3: 'Auswahl der Entschädigungslösung',
    step4: 'Zusammenfassung'
  }
}
